import Splide from '@splidejs/splide';

export function startArticle(){
   
    if(document.getElementsByClassName('articleGallery').length){

        let articleGalleries = new Splide('.articleGallery',{
                type: "slide",
                gap:"1em",
                padding: {right:'5rem'},
        })
        articleGalleries.mount()


    }

}